<div class="padding">
  <b>Media history</b>

  @if (loading) {
    <bt-loader></bt-loader>
  } @else if (shots.length) {
    <div class="flex column margin-top">
      <div class="media-timeline flex center scrollable mini-scrollbar margin-top-smallest">
        @for (shot of shots; track $index) {
          <div class="media-timeline-entry flex column center">
            <div
              class="media-timeline-item border hover {{ currentIndex === $index ? 'active' : '' }}"
              (click)="selectShot($index)"
            >
              @if (getShotMediaKind(shot) === 'image') {
                <img class="media-timeline-thumb" [src]="shot.imgPath" alt="History thumbnail" />
              } @else if (getShotMediaKind(shot) === 'video') {
                <div class="media-timeline-thumb flex center justify-center bg-light-grey">
                  <i class="fa-solid fa-circle-play primary"></i>
                </div>
              } @else {
                <div class="media-timeline-thumb flex center justify-center bg-light-grey">
                  <i class="fa-solid fa-image grey"></i>
                </div>
              }
            </div>

            <div class="media-timeline-rail flex center">
              <span class="media-timeline-rail-line"></span>
              <span class="media-timeline-rail-dot {{ currentIndex === $index ? 'active' : '' }}"></span>
            </div>
            @if (shot.source?.date) {
              <div class="small grey media-timeline-date">{{ shot.source.date | date: 'dd/MM/yyyy' }}</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="flex center margin-top">
      <div
        class="circle flex center justify-center bg-primary-dark white hover {{ isFirst() ? 'disabled' : '' }}"
        (click)="goPrevious()"
      >
        <i class="fa fa-solid fa-arrow-left"></i>
      </div>

      <div class="flex-1 flex column center padding-small">
        @if (mediaKind === 'image') {
          <img class="media-content" [src]="currentShot?.imgPath" alt="Media preview" />
        } @else if (mediaKind === 'video') {
          <video class="media-content" [src]="currentShot?.imgPath" controls></video>
        } @else {
          <div class="card padding flex column center">
            <span class="bold">Media not supported</span>
          </div>
        }

        <div class="flex column center margin-top">
          <span class="grey margin-bottom-smallest">{{ currentIndex + 1 }} / {{ shots.length }}</span>
          <div class="flex center">
            @if (currentShot.isAi) {
              <i class="fa-solid fa-robot primary margin-right-smallest" matTooltip="AI generated"></i>
            }
            <b>{{ currentShot?.shotType?.name }}</b>
          </div>
          @if (currentShot?.source) {
            <div class="margin-top-smallest small">
              @if (currentShot.source.orderId) {
                <div class="flex center">
                  <div class="grey">Source:</div>
                  <div class="primary hover margin-left-smallest" (click)="openSourceOrder(currentShot.source.orderId)">
                    Order #{{ currentShot.source.orderId }}
                  </div>
                </div>
              } @else {
                <div class="grey">Source: Manual upload</div>
              }
              @if (currentShot.source.date) {
                <div class="grey">Confirmed date: {{ currentShot.source.date | date: 'dd/MM/yyyy HH:mm' }}</div>
              }
            </div>
          }
        </div>
      </div>

      <div
        class="circle flex center justify-center bg-primary-dark white hover {{ isLast() ? 'disabled' : '' }}"
        (click)="goNext()"
      >
        <i class="fa fa-solid fa-arrow-right"></i>
      </div>
    </div>
  }

  <div class="flex column end margin-top">
    <div class="flex center">
      <button class="stroked margin-right-small" (click)="close()">
        <i class="fa-solid fa-undo"></i>
        Close
      </button>
      @if (shots.length) {
        <button (click)="selectThisImage()" [disabled]="saving || !currentShot?.id">
          <i class="fa-solid fa-check"></i>
          Select this image
        </button>
      }
    </div>
  </div>
</div>

@if (saving) {
  <bt-loader></bt-loader>
}
